// src/constants/proposalStatusConfig.js
//
// Pill / icon / label maps for the 8 proposal lifecycle statuses.
// Mirrors the shape of the (deleted) OfferCard STATUS_PILL_CLASS / STATUS_ICON
// / STATUS_LABEL maps so swapping in is mechanical.
//
// Pill classes are global tokens from src/styles/vennio-tokens.css. The
// `pill-progress` class is a local variant (added in ProposalCard.module.css)
// used for transient `accepting` / `cancelling` states.
import {
  Timer,
  CheckCircle,
  XCircle,
  Clock,
  Repeat,
  Loader2,
} from 'lucide-react';

// TODO(naming) proposal status pill labels surface in customer + business dashboards
export const STATUS_LABEL = {
  proposed:   'Awaiting response', // TODO(naming) status label
  accepting:  'Accepting…',        // TODO(naming) status label
  accepted:   'Confirmed',         // TODO(naming) status label
  cancelling: 'Cancelling…',       // TODO(naming) status label
  cancelled:  'Cancelled',         // TODO(naming) status label
  rejected:   'Declined',          // TODO(naming) status label
  expired:    'Expired',           // TODO(naming) status label
  countered:  'Counter-proposed',  // TODO(naming) status label
};

export const STATUS_ICON = {
  proposed:   Timer,
  accepting:  Loader2,
  accepted:   CheckCircle,
  cancelling: Loader2,
  cancelled:  XCircle,
  rejected:   XCircle,
  expired:    Clock,
  countered:  Repeat,
};

// Maps status → global pill-* class from vennio-tokens.css.
// `pill-progress` is module-local (defined in ProposalCard.module.css).
export const STATUS_PILL_CLASS = {
  proposed:   'pill-warning',
  accepting:  'pill-progress',
  accepted:   'pill-success',
  cancelling: 'pill-progress',
  cancelled:  'pill-neutral',
  rejected:   'pill-error',
  expired:    'pill-neutral',
  countered:  'pill-accent',
};
